import { useQuery } from "react-query";


import { getCountries } from "../../../../../MyApi/sb/countries";
import { getCurrency } from "../../../../../MyApi/sb/currency";
import { getCompanyFields } from "../../../../../MyApi/sb/companyfields";

import Select from "react-select"
import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";

import classes from "./addCompanies.module.css";

const EditCompanies = ({
  companyName,countryId,
  setActive, active, address, states, slug, website, email, mobile, comapnyFiledId, currencyId,  setComapnyName,  setAddress, setStates, setSlug, setWebsite, setEmail,setMobile, setCompanyFiledId,setCountryId, setCurrencyId
  
}) => {
 const countriesQuery= useQuery("getcountries" , getCountries)
 const currenciesQuery = useQuery("getcurrencies" , getCurrency)
 const companyFiledsQuery = useQuery("getcompanyfields" , getCompanyFields)
 const countries = countriesQuery.data?.data || []
 const currencies = currenciesQuery.data?.data || []
 const companyFields = companyFiledsQuery.data?.data || []

  const City = icons.City
  const Earth = icons.Earth
  const Phone = icons.phone
  const Address =icons.address
  const Email = icons.email
  const Dollar = icons.Dollar
  const Field = icons.company

  const defaultCountry = countries.find(option => option.id === countryId);
  const defaultCurrencies =currencies.find(option => option.id === currencyId)
  const defaultCompanyFields =companyFields.find(option => option.id === comapnyFiledId)

  const handleNameChange = (e) => {
    setComapnyName(e.target.value);
  };
  const handlePhoneChange = (e) => {
    setMobile(e.target.value);
  };
  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handleWebsiteChange =(e)=>{
 setWebsite(e.target.value)
  }
  const handleSlugChange = (e)=>{
    setSlug(e.target.value)
  }
  const handleCountryIdChange = (selectedOption) => {
    const countryId = selectedOption ? selectedOption.id :0
    setCountryId(countryId);
  };
  const handleCurrencyIdChange = (selectedOption) => {
    const currencyId = selectedOption? selectedOption.id :0
    setCurrencyId(currencyId);
  };
  const handleCompanyFiledIdChange = (selectedOption) => {
    const companyFieldId = selectedOption ? selectedOption.id :0
    setCompanyFiledId(companyFieldId);
  };
  const handleStateChange =(e)=>{
    setStates(e.target.value)
  }
  const handleActiveChange =(e)=>{
    const isChecked =e.target.checked
   setActive(isChecked ?1 :0)
  }

if(countriesQuery.isLoading || currenciesQuery.isLoading || companyFiledsQuery.isLoading){
  return <LoadingSpinner/>
}

  return (
    <div className={classes.formCard}>
      <h5 className={classes.headTitle}>معلومات الشركة</h5>

      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">اسم الشركة</label>
          <div className={classes.iconInput}>
            <City />
          </div>
          <input
            type="text"
            placeholder="ادخل اسم الشركة"
            value={companyName}
            onChange={handleNameChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">رقم الهاتف </label>
          <div className={classes.iconInput}>
            <Phone />  
          </div>
          <input
            type="text"
            placeholder="ادخل رقم  الهاتف"
            value={mobile}
            onChange={handlePhoneChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> العنوان</label>
          <div className={classes.iconInput}>
            <Address />
          </div>
          <input
            type="text"
            value={address}
            placeholder="ادخل عنوان الشركة"
            onChange={handleAddressChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">الإيميل </label>
          <div className={classes.iconInput}>
            <Email />
          </div>
          <input
            type="text"
            placeholder="ادخل ايميل الشركة"
            value={email}

            onChange={handleEmailChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> الموقع الالكتروني </label>
          <div className={classes.iconInput}>
            <Email />
          </div>
          <input
            type="text"
            placeholder="ادخل الموقع الالكتروني للشركة"
            value={website}
            onChange={handleWebsiteChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> الاسم المستعار </label>
          <div className={classes.iconInput}>
            <Email />
          </div>
          <input
            type="text"
            placeholder="ادخل  الاسم المستعار للشركة"
            value={slug}
            onChange={handleSlugChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">  المحافظة/الدولة  </label>
          <div className={classes.iconInput}>
            <City />
          </div>
          <input
            type="text"
            placeholder="  ادخل المحافظة  "
            value={states}
            onChange={handleStateChange}
            className={classes.inputCustom}
          />
        </div>
      
      
        <div className={classes.formCol}>
          <label htmlFor=""> اختار الدولة</label>
          {!countriesQuery.data ? <div>no data avalible</div> :
          <Select
            type="text"
            placeholder="اختر الدولة"
            defaultValue={defaultCountry}
            options={countries}
            getOptionValue={(e) => e.id}
            getOptionLabel={(e) => e.name}
            onChange={handleCountryIdChange}
          />}
           
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> اختار العملة</label>
      
          {!currenciesQuery.data ? <div>no data avalible</div> :
          <Select
            type="text"
            placeholder="اختار العملة"
            defaultValue={defaultCurrencies}
            options={currencies}
            getOptionValue={(e) => e.id}
            getOptionLabel={(e) => e.name}
            onChange={handleCurrencyIdChange}
          />
           }
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> اختار مجال الشركة</label>
         
          {!companyFiledsQuery.data ? <div>no data avalible</div> :
          <Select
           defaultValue={defaultCompanyFields}
            options={companyFields}
            getOptionValue={(e) => e.id}
            getOptionLabel={(e) => e.name}
            type="text"
            placeholder="اختار مجال الشركة"
            onChange={handleCompanyFiledIdChange}
            
          />}
        </div>
        <div className={classes.formCol}>
          <label htmlFor="active"  className={active ? `${classes.active}` : `${classes.disActive}`}>   {active===1 ?" نشط":"غير نشط"} </label>
         
         <label class="switch">
          <input type="checkbox" onChange={handleActiveChange} checked={active}/>
            <span class="slider round"></span>
        </label> 
    
           </div>

     
      </div>
    </div>
  );
};

export default EditCompanies;
